import { EasyDataTable } from '@easydata/core';
var EasyQueryDataLoader = /** @class */ (function () {
    function EasyQueryDataLoader(context) {
        this.context = context;
    }
    EasyQueryDataLoader.prototype.loadChunk = function (chunk) {
        var _this = this;
        // We have to refactor page logic in view to make it simplier to integrate 
        // different grids
        this.dataLoadPromise = new Promise(function (resolve, reject) {
            var fetchOptions = {
                chunk: chunk,
                success: function (result) {
                    var dataTable = new EasyDataTable({
                        loader: _this.context.dataLoader,
                        chunkSize: _this.context.resultTable.chunkSize
                    });
                    var resultSet = result.resultSet;
                    for (var _i = 0, _a = resultSet.cols; _i < _a.length; _i++) {
                        var col = _a[_i];
                        dataTable.columns.add(col);
                    }
                    dataTable.setTotal(result.meta.totalRecords);
                    for (var _b = 0, _c = resultSet.rows; _b < _c.length; _b++) {
                        var row = _c[_b];
                        dataTable.addRow(row);
                    }
                    var totalRecords = 0;
                    if (result.meta && result.meta.totalRecords) {
                        totalRecords = result.meta.totalRecords;
                    }
                    resolve({
                        table: dataTable,
                        total: totalRecords,
                        hasNext: !chunk.needTotal || chunk.offset + chunk.limit < totalRecords
                    });
                },
                error: function (error) { return reject(error); }
            };
            if (_this.context.debugMode) {
                fetchOptions.debug = "Data Chunk. Offset: " + chunk.offset;
            }
            _this.context.fetchDataChunk(fetchOptions);
        });
        return this.dataLoadPromise;
    };
    return EasyQueryDataLoader;
}());
export { EasyQueryDataLoader };
//# sourceMappingURL=eq_data_loader.js.map